<script>
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import CustomSearch from "../../../components/CustomSearch/CustomSearch.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";

	export let isOpen = false;
	export let workshopOptions = [];
	export let workshopOption = null;
	export let workshopSaveError = "";
	export let isSaving = false;
	export let isLoadingWorkshops = false;
	export let hasLoadedWorkshops = false;
	export let workshopLoadError = "";
	export let workshopSearchError = "";
	export let loadOptions = undefined;
	export let filterText = "";
	export let onCancel = () => {};
	export let onSave = () => {};

	// Same as the Issues list / Create issue catalogs: the field itself says
	// when the list is loading, failed or empty.
	$: placeholder = isLoadingWorkshops
		? "Loading workshops..."
		: workshopLoadError
			? "Failed to load workshops"
			: hasLoadedWorkshops && !workshopOptions.length
				? "No workshops available"
				: "Select a workshop";
	// Also shown when a workshop is already picked (placeholder hidden).
	$: fieldError = workshopLoadError
		? "Failed to load workshops"
		: workshopSearchError
			? "Couldn't search workshops"
			: "";
</script>

<Modal {isOpen} toggle={onCancel} centered>
	<ModalHeader toggle={onCancel}>Indicate workshop</ModalHeader>
	<ModalBody>
		<ErrorMessageHandler message={workshopSaveError} />
		<p class="mb-4">
			Select the workshop that will be working on this work order.
		</p>
		<label for="workshopName" class="d-block"
			>Workshop<span class="text-danger">*</span></label
		>
		<div id="workshopName" class="mt-1">
			<CustomSearch
				items={workshopOptions}
				{loadOptions}
				{placeholder}
				error={!!fieldError}
				errorText={fieldError}
				bind:value={workshopOption}
				bind:filterText
				chevron
			/>
		</div>
	</ModalBody>
	<ModalFooter>
		<Button
			class="themeButton backButton"
			disabled={isSaving}
			on:click={onCancel}>Cancel</Button
		>
		<Button
			class="themeButton primary"
			disabled={isSaving || !workshopOption}
			on:click={onSave}>Save</Button
		>
	</ModalFooter>
</Modal>
